import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import UsingOptions from './UsingOptions';
import ClientProvider from './client';
export default createDemo(import.meta.url, UsingOptions, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/styled/demos/using-options/UsingOptions.tsx",
    "fileName": "UsingOptions.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled, createTheme, ThemeProvider } from '@mui/system';\n\ninterface MyThemeComponentProps {\n  color?: 'primary' | 'secondary';\n  variant?: 'normal' | 'dashed';\n}\n\nconst customTheme = createTheme({\n  components: {\n    MyThemeComponent: {\n      styleOverrides: {\n        root: {\n          color: 'darkslategray',\n        },\n        primary: {\n          color: 'darkblue',\n        },\n        secondary: {\n          color: 'darkred',\n          backgroundColor: 'pink',\n        },\n      },\n      variants: [\n        {\n          props: { variant: 'dashed', color: 'primary' },\n          style: {\n            border: '1px dashed darkblue',\n          },\n        },\n        {\n          props: { variant: 'dashed', color: 'secondary' },\n          style: {\n            border: '1px dashed darkred',\n          },\n        },\n      ],\n    },\n  },\n});\n\nconst MyThemeComponent = styled('div', {\n  // Configure which props should be forwarded on DOM\n  shouldForwardProp: (prop) =>\n    prop !== 'color' && prop !== 'variant' && prop !== 'sx',\n  name: 'MyThemeComponent',\n  slot: 'Root',\n  // We are specifying here how the styleOverrides are being applied based on props\n  overridesResolver: (props, styles) => [\n    styles.root,\n    props.color === 'primary' && styles.primary,\n    props.color === 'secondary' && styles.secondary,\n  ],\n})<MyThemeComponentProps>(({ theme }) => ({\n  backgroundColor: 'aliceblue',\n  padding: theme.spacing(1),\n}));\n\nexport default function UsingOptions() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={customTheme}>\n      <MyThemeComponent sx={{ m: 1 }} color=\"primary\" variant=\"dashed\">\n        Primary\n      </MyThemeComponent>\n      <MyThemeComponent sx={{ m: 1 }} color=\"secondary\">\n        Secondary\n      </MyThemeComponent>\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 69,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled, createTheme, ThemeProvider } from '@mui/system';\n\ninterface MyThemeComponentProps {\n  color?: 'primary' | 'secondary';\n  variant?: 'normal' | 'dashed';\n}\n\nconst customTheme = createTheme({\n  components: {\n    MyThemeComponent: {\n      styleOverrides: {\n        root: {\n          color: 'darkslategray',\n        },\n        primary: {\n          color: 'darkblue',\n        },\n        secondary: {\n          color: 'darkred',\n          backgroundColor: 'pink',\n        },\n      },\n      variants: [\n        {\n          props: { variant: 'dashed', color: 'primary' },\n          style: {\n            border: '1px dashed darkblue',\n          },\n        },\n        {\n          props: { variant: 'dashed', color: 'secondary' },\n          style: {\n            border: '1px dashed darkred',\n          },\n        },\n      ],\n    },\n  },\n});\n\nconst MyThemeComponent = styled('div', {\n  // Configure which props should be forwarded on DOM\n  shouldForwardProp: (prop) =>\n    prop !== 'color' && prop !== 'variant' && prop !== 'sx',\n  name: 'MyThemeComponent',\n  slot: 'Root',\n  // We are specifying here how the styleOverrides are being applied based on props\n  overridesResolver: (props, styles) => [\n    styles.root,\n    props.color === 'primary' && styles.primary,\n    props.color === 'secondary' && styles.secondary,\n  ],\n})<MyThemeComponentProps>(({ theme }) => ({\n  backgroundColor: 'aliceblue',\n  padding: theme.spacing(1),\n}));\n\nexport default function UsingOptions() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={customTheme}>\n      <MyThemeComponent sx={{ m: 1 }} color=\"primary\" variant=\"dashed\">\n        Primary\n      </MyThemeComponent>\n      <MyThemeComponent sx={{ m: 1 }} color=\"secondary\">\n        Secondary\n      </MyThemeComponent>\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 60
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "customTheme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 61
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "primary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "dashed",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 62
            },
            "        Primary"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 63
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 64
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "m"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "color"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "secondary",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 65
            },
            "        Secondary"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 66
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "MyThemeComponent"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 67
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 69,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
